import type { QueryMetricsType } from './queryMetricsType';
import type { QueryMetricsGroupBy } from './queryMetricsGroupBy';

export type QueryMetricsParams = {
/**
 * Metric type filter
 */
type?: QueryMetricsType;
/**
 * Start date for metrics query
 */
startDate: string;
/**
 * End date for metrics query
 */
endDate: string;
/**
 * Group metrics by time period
 */
groupBy?: QueryMetricsGroupBy;
/**
 * Maximum number of results
 */
limit?: number;
};
